import { onError } from "@apollo/client/link/error"
import { addBreadcrumb, setContext, setTag } from "@sentry/browser"

export const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  addBreadcrumb({ message: operation.operationName, type: "graphql", level: "info" })
  setContext("variables", operation.variables)

  if (graphQLErrors) {
    setTag("errorType", "GraphQL error")

    graphQLErrors.forEach(({ message, path }) =>
      addBreadcrumb({
        message: `[GraphQL error]: Message: ${message}, Path: ${path}`,
        type: "graphql",
        level: "info",
      }),
    )
  }

  if (networkError) {
    setTag("errorType", "Network error")

    addBreadcrumb({
      message: `[Network error]: ${networkError}`,
      type: "graphql",
      level: "info",
    })
  }
})
